module.exports = __webpack_public_path__ + "img/full0-min.e0642298.png";